import React from 'react';
import { useTranslation } from 'react-i18next';
import type { BrandingSettings } from '../types';

interface PayslipPreviewProps {
  settings: BrandingSettings;
}

const PayslipPreview: React.FC<PayslipPreviewProps> = ({ settings }) => {
  const { t } = useTranslation();
  const { headerSettings, logoSettings, footerSettings } = settings;

  return (
    <div className="bg-muted rounded-lg p-4 mb-6">
      <h4 className="text-sm font-medium text-muted-foreground mb-3">
        {t('Live Preview')}
      </h4>
      <div className="bg-card border border-border rounded p-4 text-xs">
        {/* Header area */}
        <div
          className="flex items-center justify-between mb-3 rounded"
          style={{
            backgroundColor: headerSettings.headerBackgroundColor,
            color: headerSettings.headerColor,
            padding: '8px',
          }}
        >
          <div>
            <h3 className="font-bold">{headerSettings.companyName}</h3>
            <p>{headerSettings.headerText}</p>
          </div>
          {logoSettings.hasLogo && (
            <div className="w-12 h-12 bg-muted rounded flex items-center justify-center">
              <span className="text-xs text-muted-foreground">{t('Logo')}</span>
            </div>
          )}
        </div>

        {/* Content area */}
        <div className="text-center py-8 border-t border-b border-border">
          <p className="text-muted-foreground">{t('Payslip Content Area')}</p>
          <p className="text-xs text-muted-foreground/70">
            {t('Employee details, salary breakdown, etc.')}
          </p>
        </div>

        {/* Footer area */}
        <div className="mt-3 text-xs text-muted-foreground">
          <p>{footerSettings.footerText}</p>
          {footerSettings.includeDisclaimer && (
            <p className="mt-1 text-xs">{footerSettings.disclaimerText}</p>
          )}
          {footerSettings.showHelpContact && (
            <p className="mt-1">
              {t('Contact')}: {footerSettings.helpContact}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PayslipPreview;
